import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Menu = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 16 16"
    {...props}
    sx={{ fill: 'none', ...(props.sx || {}) }}
  >
    <path d="M2 3H14.75" stroke="currentColor" strokeLinecap="round" />
    <path d="M2 8H14.75" stroke="currentColor" strokeLinecap="round" />
    <path d="M2 13H14.75" stroke="currentColor" strokeLinecap="round" />
  </SvgIcon>
);
